import { useState, useEffect, useCallback } from "react";
import "../common/Util.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { Dropdown } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel";
import DateRangePicker from "../common/dateRange";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { getVehiclesListApi, deleteVehicleApi } from "./vehicle-api";
import { useGlobal } from "../../GlobalContext";
import editIcon from "../../assets/svg/edit_ic.svg";
import deleteIcon from "../../assets/svg/delete_ic.svg";
import moreIcon from "../../assets/svg/more_ic.svg";
import vehicleIcon from "../../assets/svg/vehicle_ic.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import "../common/skeleton-effect.css";
import CommonSnackbar, { CommonPagination } from "../common/reusable-commponent";
import { sanitizeInput, sanitizeNumericInput } from "../common/security-utils";

export const VehicleListing = () => {
  const { rolePermissionList, userType } = useGlobal();
  function checkPermission(permission) {
    return rolePermissionList.findIndex((element) => element["name"] === "Vehicle" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }

  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const iconStyle = { width: "16px", height: "16px" };
  const [search, setSearch] = useState("");
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const [statusList, setStatusList] = useState([
    { value: "", label: "All" },
    { value: true, label: "Active" },
    { value: false, label: "InActive" },
  ]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [active, setActive] = useState("list");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [vehiclesList, setVehiclesList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ show: false, message: "", status: false });

  const triggerSnackbar = (message, status) => {
    setSnackbar({ show: true, message: sanitizeInput(message), status });
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, show: false }));
  };

  const [statusSelect, setStatusSelect] = useState(null);
  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const sortByOption = [
    { value: "created asc", label: "Created (Oldest)" },
    { value: "created desc", label: "Created (Newest)" },
    { value: "vehicle_no asc", label: "Vehicle No (A - Z)" },
    { value: "vehicle_no desc", label: "Vehicle No (Z - A)" },
  ];

  const handleDateChange = ({ start, end }) => {
    setStartDate(start);
    setEndDate(end);
    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;
    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };

  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);

  useEffect(() => {
    getVehiclesList();
  }, [itemsPerPage, itemOffset, search, selectedSortby, statusSelect, startDateSave, endDateSave]);

  const getVehiclesList = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || ["created", "desc"];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: sanitizeInput(search),
      status: statusSelect?.value ?? "",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
    };
    try {
      const response = await getVehiclesListApi(param);
      if (response && response.data && response.data.success === true) {
        setTotalCount(response.data.total_recs ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setVehiclesList(response.data.vehicle ?? []);
      }
    } catch {
      // Error handled by snackbar if needed, but usually silent on list fetch failures
    } finally {
      setIsLoading(false);
    }
  };

  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const deleteVehicle = async () => {
    try {
      const response = await deleteVehicleApi(deleteId);
      if (response && response.data && response.data.success === true) {
        triggerSnackbar(response.data.message || "Vehicle deleted successfully", true);
        getVehiclesList();
        setDeleteId(null);
        setIsOpenDelete(false);
      } else {
        triggerSnackbar(response.data?.message || "Failed to delete vehicle", false);
      }
    } catch {
      triggerSnackbar("An error occurred while deleting vehicle", false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <DeleteModal
        title={"vehicle"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false);
          setDeleteId(null);
        }}
        onDelete={deleteVehicle}
      />
      <div>
        <div className="my-2">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="my-heading fs-24 fw-600" style={{ color: "#9299A7" }}>
              VEHICLES : {totalCount}
            </div>

            <div className="d-flex flex-wrap gap-3">
              <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                <SearchIc />
                <input type="text" placeholder="Search" className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor" value={search || ""} maxLength={50} onChange={(e) => setSearch(sanitizeInput(e.target.value))} />
              </div>

              {checkPermission("create_permission") && (
                <div className="cursor-pointer add-new d-flex align-items-center justify-content-center gap-2 px-3" onClick={() => navigate("/vehicle/create")} style={{ height: "40px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <AddIc style={{ width: "16px", height: "16px" }} />
                  </div>
                  <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                    Add Vehicle
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex flex-wrap justify-content-start gap-2">
              <div onClick={(e) => e.stopPropagation()}>
                <Dropdown>
                  <Dropdown.Toggle
                    variant="light"
                    id="dropdown-sort"
                    className="d-flex align-items-center justify-content-between"
                    style={{
                      borderRadius: "12px",
                      border: "1px solid #EBEBEB",
                      padding: "6px 12px",
                      backgroundColor: "white",
                    }}
                    title={selectedSortby.label}
                  >
                    <span className="fs-12 fw-400 textGrey">Sort by :</span>
                    <span className="d-flex align-items-center px-1">
                      <span className="dropdown-text">{selectedSortby.label}</span>
                    </span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    style={{
                      backgroundColor: "white",
                      borderRadius: "8px",
                      border: "1px solid #EBEBEB",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {sortByOption.map((option) => (
                      <Dropdown.Item
                        className="fs-14 fw-500 textcolor"
                        key={option.value}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedSortBy(option);
                        }}
                        active={selectedSortby === option.value}
                      >
                        {option.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <div
                className="d-flex align-items-center px-1"
                style={{
                  borderRadius: "8px",
                  height: "32px",
                  border: "1px solid #EBEBEB",
                  backgroundColor: "white",
                }}
              >
                <span className="fs-12 fw-400 textGrey">Date :</span>
                <div className="dropdown-text1 ms-2" style={{ marginBottom: "4px" }}>
                  <DateRangePicker onChange={handleDateChange} startDate={startDate} endDate={endDate} style={{ border: "none", padding: "0", backgroundColor: "transparent" }} />
                </div>
              </div>

              <div
                className="cursor-pointer ms-1 fs-12 fw-400 textGrey text-decoration-underline d-flex align-items-center justify-content-center"
                style={{ height: "30px" }}
                onClick={() => {
                  setStatusSelect(null);
                  setStartDateSave(null);
                  setEndDateSave(null);
                  setStartDate(null);
                  setEndDate(null);
                  setSelectedSortBy({
                    value: "created desc",
                    label: "Created (Newest)",
                  });
                }}
              >
                Reset Filters
              </div>
            </div>

            <div
              className="rounded-3 toggleBg d-flex mt-2"
              style={{
                width: "80px",
                height: "32px",
                backgroundColor: "#FFFFFF",
                padding: "4px",
                gap: "4px",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #EBEBEB",
              }}
            >
              <div
                onClick={() => setActive("list")}
                className={`d-flex align-items-center justify-content-center rounded-3 ${active === "list" ? "bg-primary1" : ""}`}
                style={{
                  width: "36px",
                  height: "24px",
                  cursor: "pointer",
                }}
              >
                {active === "list" ? <ListView style={iconStyle} /> : <SelectList style={iconStyle} />}
              </div>

              <div
                onClick={() => setActive("grid")}
                className={`d-flex align-items-center justify-content-center rounded-3 ${active === "grid" ? "bg-primary1" : ""}`}
                style={{
                  width: "36px",
                  height: "24px",
                  cursor: "pointer",
                }}
              >
                {active === "grid" ? <SelectGrid style={iconStyle} /> : <EmailView style={iconStyle} />}
              </div>
            </div>
          </div>
        </div>

        {active === "list" && (
          <div className="w-100 trip-table-wrapper bg-white rounded-4 w-100">
            <div
              style={{
                display: "flex",
                flex: "7",
                paddingLeft: "16px",
                paddingRight: "16px",
                paddingTop: "16px",
                height: "40px",
                backgroundColor: "#FFFFFF",
                border: "1px solid #e5e5e5",
              }}
              className="head3 w-100 justify-content-start align-items-center"
            >
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                VIN
              </p>
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                VEHICLE NAME
              </p>
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                TYPE
              </p>
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                LICENSE PLATE
              </p>
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                LOAD CAPACITY
              </p>
              <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                DIMENSION
              </p>
            </div>
            <div>
              {isLoading ? (
                // Skeleton Loading for List View
                <>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        flex: "10",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        backgroundColor: "#FFFFFF",
                        borderBottom: "1px solid #D4DDE7",
                        borderLeft: "1px solid #D4DDE7",
                        borderRight: "1px solid #D4DDE7",
                        height: "44px",
                      }}
                      className="head3 w-100 justify-content-center align-items-center"
                    >
                      <div style={{ flex: "1" }} className="table-row-p">
                        <div className="skeleton skeleton-text" style={{ width: "80%", height: "14px" }}></div>
                      </div>
                      <div style={{ flex: "1" }} className="table-row-p">
                        <div className="skeleton skeleton-text" style={{ width: "70%", height: "14px" }}></div>
                      </div>
                      <div style={{ flex: "1" }} className="table-row-p">
                        <div className="skeleton skeleton-text" style={{ width: "60%", height: "14px" }}></div>
                      </div>
                      <div style={{ flex: "1" }} className="table-row-p">
                        <div className="skeleton skeleton-text" style={{ width: "75%", height: "14px" }}></div>
                      </div>
                      <div style={{ flex: "1" }} className="table-row-p">
                        <div className="skeleton skeleton-text" style={{ width: "65%", height: "14px" }}></div>
                      </div>
                      <div style={{ flex: "1" }} className="table-row-p">
                        <div className="skeleton skeleton-text" style={{ width: "70%", height: "14px" }}></div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                (vehiclesList ?? []).map((item, index) => (
                  <div
                    style={{
                      display: "flex",
                      flex: "10",
                      paddingLeft: "16px",
                      paddingRight: "16px",
                      backgroundColor: hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                      borderBottom: "1px solid #D4DDE7",
                      borderLeft: "1px solid #D4DDE7",
                      borderRight: "1px solid #D4DDE7",
                      cursor: "pointer",
                      height: "44px",
                      position: "relative",
                      overflow: "hidden",
                    }}
                    onClick={() => {
                      if (checkPermission("view_permission")) {
                        navigate("/vehicle/view", {
                          state: { id: item.id },
                        });
                      }
                    }}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    className="head3 w-100 justify-content-center align-items-center"
                  >
                    <p
                      className="fs-13 fw-500 textcolor text-start table-row-p"
                      style={{
                        flex: "1",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        marginTop: "16px",
                      }}
                      title={sanitizeInput(String(item.vin || ""))}
                    >
                      {sanitizeInput(String(item.vin || "---"))}
                    </p>
                    <p
                      className="fs-13 fw-500 textcolor text-start table-row-p"
                      style={{
                        flex: "1",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        marginTop: "16px",
                      }}
                      title={sanitizeInput(String(item.vehicle_name || ""))}
                    >
                      {sanitizeInput(String(item.vehicle_name || "---"))}
                    </p>
                    <p
                      className="fs-13 fw-500 textcolor text-start table-row-p"
                      style={{
                        flex: "1",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        marginTop: "16px",
                      }}
                      title={sanitizeInput(String(item.type || ""))}
                    >
                      {sanitizeInput(String(item.type || "---"))}
                    </p>
                    <p
                      className="fs-13 fw-500 textcolor text-start table-row-p"
                      style={{
                        flex: "1",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        marginTop: "16px",
                      }}
                      title={sanitizeInput(String(item.license_plate || ""))}
                    >
                      {sanitizeInput(String(item.license_plate || "---"))}
                    </p>
                    <p
                      className="fs-13 fw-500 textcolor text-start table-row-p"
                      style={{
                        flex: "1",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        marginTop: "16px",
                      }}
                      title={sanitizeInput(String(item.load_capacity || ""))}
                    >
                      {sanitizeInput(String(item.load_capacity || "---"))}
                    </p>
                    <p
                      className="fs-13 fw-500 textcolor text-start table-row-p"
                      style={{
                        flex: "1",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        marginTop: "16px",
                      }}
                      title={sanitizeInput(String(item.dimension || ""))}
                    >
                      {sanitizeInput(String(item.dimension || "---"))}
                    </p>
                    {hoveredIndex === index && (
                      <div
                        style={{
                          position: "absolute",
                          right: "35px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "start",
                            alignItems: "center",
                          }}
                        >
                          {checkPermission("edit_permission") && (
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate("/vehicle/create", {
                                  state: { id: item.id },
                                });
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                                background: "#FFFFFF",
                                cursor: "pointer",
                                border: "0.8px solid #E5E5E5",
                              }}
                            >
                              <img src={editIcon} alt="edit" />
                            </div>
                          )}
                          <span style={{ marginLeft: "16px" }}></span>
                          {checkPermission("delete_permission") && (
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteId(item.id);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                                background: "#FFFFFF",
                                cursor: "pointer",
                                border: "0.8px solid #E5E5E5",
                              }}
                            >
                              <img src={deleteIcon} alt="delete" />
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          </div>
        )}

        {active === "grid" && (
          <>
            {isLoading ? (
              // Skeleton Loading for Grid View
              <>
                {[1, 2, 3].map((i) => (
                  <div key={i} className="bg-white rounded-4 d-flex flex-wrap align-items-center justify-content-between business-card w-100 p-3 mb-3">
                    <div className="col-12 col-md-6 col-lg-3 d-flex pe-2" style={{ borderRight: "1px solid #EBEBEB" }}>
                      <div className="skeleton skeleton-avatar" style={{ width: "64px", height: "64px", borderRadius: "12px" }}></div>
                      <div className="d-flex flex-column justify-content-center align-items-start gap-2 ps-3 flex-grow-1">
                        <div className="skeleton skeleton-text-lg" style={{ width: "150px" }}></div>
                        <div className="skeleton skeleton-text-sm" style={{ width: "100px" }}></div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 ps-3 d-flex flex-column align-items-start justify-content-start pe-1" style={{ borderRight: "1px solid #EBEBEB" }}>
                      <div className="skeleton skeleton-text mb-2" style={{ width: "200px", height: "14px" }}></div>
                      <div className="skeleton skeleton-text mb-2" style={{ width: "180px", height: "14px" }}></div>
                      <div className="skeleton skeleton-text mb-2" style={{ width: "160px", height: "14px" }}></div>
                      <div className="skeleton skeleton-text" style={{ width: "140px", height: "14px" }}></div>
                    </div>

                    <div className="d-flex flex-row align-items-end justify-content-end gap-2 ps-3">
                      <div className="skeleton skeleton-button" style={{ width: "36px", height: "36px", borderRadius: "100px" }}></div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              vehiclesList.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-4 d-flex flex-wrap align-items-center justify-content-between business-card w-100 p-3 mb-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (checkPermission("view_permission")) {
                      navigate("/vehicle/view", {
                        state: { id: item.id },
                      });
                    }
                  }}
                >
                  <div className="col-12 col-md-6 col-lg-3 d-flex pe-2" style={{ borderRight: "1px solid #EBEBEB" }}>
                    <div className="profile-wrapper" style={{ background: "#F4F4F4" }}>
                      <img key={index} src={vehicleIcon} alt="vehicle" className="profile-img" />
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-start gap-1 ps-3">
                      <div className="textFontColor fs-16 fw-600">{sanitizeInput(String(item.vehicle_name || "-"))}</div>
                      <div className="d-flex gap-2 align-items-center">
                        <span className="text-gray fs-12 fw-500">{sanitizeInput(String(item.vehicle_name || ""))}</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-3 ps-3 d-flex flex-column align-items-start justify-content-start pe-1" style={{ borderRight: "1px solid #EBEBEB" }}>
                    <div className="d-flex flex-column flex-grow-1 align-items-start">
                      <div className="fs-12 fw-600 cardTextGrey">
                        TYPE : <span className="fs-14 fw-400 textcolor">{sanitizeInput(String(item.type || "---"))}</span>
                      </div>
                      <div className="fs-12 fw-600 cardTextGrey mt-1">
                        LICENSE PLATE : <span className="fs-14 fw-400 textcolor">{sanitizeInput(String(item.license_plate || "---"))}</span>
                      </div>
                      <div className="fs-12 fw-600 cardTextGrey mt-1">
                        LOAD CAPACITY : <span className="fs-14 fw-400 textcolor">{sanitizeInput(String(item.load_capacity || "---"))}</span>
                      </div>
                      <div className="fs-12 fw-600 cardTextGrey mt-1">
                        DIMENSION : <span className="fs-14 fw-400 textcolor">{sanitizeInput(String(item.dimension || "---"))}</span>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex flex-row align-items-end justify-content-end gap-2 ps-3">
                    <div onClick={(e) => e.stopPropagation()}>
                      {(checkPermission("edit_permission") || checkPermission("delete_permission")) && (
                        <Dropdown>
                          <Dropdown.Toggle
                            bsPrefix="custom-toggle"
                            variant="light"
                            id="dropdown-sort"
                            className="d-flex align-items-center justify-content-between rounded-5 bg-white"
                            style={{
                              width: "36px",
                              height: "36px",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <span className="d-flex align-items-center px-1 gap-2">
                              <img src={moreIcon} alt="more" />
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            style={{
                              backgroundColor: "white",
                              borderRadius: "8px",
                              border: "1px solid #EBEBEB",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            {checkPermission("edit_permission") && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  navigate("/vehicle/create", {
                                    state: { id: item.id },
                                  });
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                            )}
                            {checkPermission("delete_permission") && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  setDeleteId(item.id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </>
        )}

        <CommonPagination itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} pageCount={pageCount + 1} onPageChange={handlePageClick} forcePage={itemOffset} />
      </div>
      <CommonSnackbar show={snackbar.show} message={snackbar.message} isSuccess={snackbar.status} onClose={handleSnackbarClose} />
    </>
  );
};
